/* eslint-disable react/prop-types */
import React from 'react';
import { Empty,  } from 'antd';

import styles from './ChartCard.less';

/**
 * ChartCard —— 图表容器
 * 放在 SectionCard 内部使用：固定高度、统一加载骨架与空态，
 * 图表本身仍由各业务组件（@ant-design/plots / echarts）渲染。
 *
 * @param height   图表容器高度，默认 320
 * @param loading  加载骨架
 * @param empty    空数据（显示 antd Empty）
 * @param emptyText 空态文案，默认「暂无数据」
 */
const ChartCard = (props) => {
  const {
    children,
    height = 320,
    empty,
    emptyText = '暂无数据',
    loading,
    className,
  } = props;

  if (loading) {
    return <div className={styles.skeleton} style={{ height }} />;
  }

  if (empty) {
    return (
      <div className={styles.empty} style={{ height }}>
        <Empty description={emptyText} />
      </div>
    );
  }

  return (
    <div className={`${styles.chart} ${className || ''}`} style={{ height }}>
      {children}
    </div>
  );
};

export default ChartCard;
